export default "__VITE_ASSET__aac963cd__"